import React, { ReactNode, Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { LoadingOverlay, MantineProvider } from '@mantine/core'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import axios from 'axios'
import { configureAxiosClient } from './axios-client'
import { Notifications } from '@mantine/notifications'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'

const queryClient = new QueryClient()
configureAxiosClient(axios)

interface Props {
  children: ReactNode
}

export function AppProviders({ children }: Props) {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <MantineProvider>
          <Notifications />
          <Suspense fallback={<LoadingOverlay visible />}>{children}</Suspense>
        </MantineProvider>
      </QueryClientProvider>
    </BrowserRouter>
  )
}
